<template>
  <div class="header-big-box">
    <div class="header-box">
      <div class="header-left">
        <span class="txt" v-if="loginSuccess">欢迎光临本店！</span>
        <span class="txt color333" v-if="!loginSuccess" @click="signInBtn">请登录</span>
        <span class="txt color333" v-if="!loginSuccess" @click="registerBtn">立即注册</span>
      </div>
      <div class="header-right">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            我的信息<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="goPersonal">个人中心</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="el-dropdown-link" @click="goShopCart">
          <i class="shopCart"></i>购物车
        </span>
        <el-dropdown>
          <span class="el-dropdown-link">
            收藏夹<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>收藏的宝贝</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown>
          <span class="el-dropdown-link">
            手机版<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><img style="width:66px;height:66px;vertical-align: middle;" src="../assets/app_code.png" alt=""></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="header-search" v-if="isShowSearch">
      <div class="header-logo">
        <img src="../assets/logo.png" alt="">
      </div>
      <div class="search-box" v-if="isSearch">
        <el-input class="input-round" placeholder="请输入关键词" prefix-icon="el-icon-full-screen">
            <el-button slot="append" style="background: #f40000;color: #fff;border-radius: 0;height: 40px">搜索</el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetRecommendBannerlist
} from '../api/api'
export default {
  name: 'AXheader',
  props: {
    isShowSearch: {
      type: Boolean,
      default: true
    },
    isSearch: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      loginSuccess: localStorage.getItem("loginSuccess"),
      
    }
  },
  created(){
    // console.log(this.loginSuccess,'999999999999')
    
  },
  methods: {
    signInBtn(){
      this.$router.push('/login')
    },
    signOutBtn(){

    },
    registerBtn(){
      this.$router.push('/register')
    },
    goShopCart(){
      this.$router.push('/shoppingCart')
    },
    handleCommand(val){
      this[val]()
    },
    goPersonal(){
      this.$router.push('/user')
    }
  }
}
</script>
<style lang="scss" scoped>
.header-big-box{
  // background: #F4F4F4;
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.header-box{
  // margin: 0 auto;
  // width: 1200px;
  height: 32px;
  line-height: 32px;
  overflow: hidden;
  .header-left{
    float: left;
  }
  .header-right{
    float: right;
    .staron{
      font-size: 20px;
      color: #f40000;
      margin-right: 5px;
    }
    .shopCart{
      display: inline-block;
      // width: 18px;
      height: 18px;
      line-height: 20px;
    }
    .shopCart::before{
      content: url(../assets/icon/shop_cart.png);
      margin-right: 5px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .txt{
    margin-right: 10px;
    color: #4f4f4f;
  }
  .color333{
    color: #f40000;
    cursor: pointer;
  }
}
.el-dropdown-link {
  margin-left: 10px;
  font-size: 16px;
  cursor: pointer;
  color: #4f4f4f;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.header-search{
  margin-top: 25px;
  width: 920px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-logo{
    width: 191px;
    height: 75px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.el-input{
  width: 554px;
}
.input-round /deep/ .el-input__inner{ 
  border-color: #f40000; 
  border-radius: 0;
  &:focus{
    outline: none;
  }
}
</style>
<style>
/* .input-round .el-input__inner{ 
    border-color: #f40000; 
    border-radius: 0;
  } */
</style>